import {useEffect, useRef} from "react";

export function useWakeLock(active: boolean) {
    const wakeLockRef = useRef<WakeLockSentinel | null>(null)

    const acquire = async () => {
        if (!("wakeLock" in navigator)) return
        try {
            wakeLockRef.current = await navigator.wakeLock.request("screen")
        } catch (e) {
            console.error("Wake lock failed:", e)
        }
    }

    const release = async () => {
        if (!wakeLockRef.current) return
        try {
            await wakeLockRef.current.release()
            wakeLockRef.current = null
        } catch (e) {
            console.error("Wake lock release failed:", e)
        }
    }

    useEffect(() => {
        if (active) acquire()
        else release()

        return () => { release() }
    }, [active])

    // re-acquire when tab becomes visible again
    // wake lock is automatically released when tab goes to background
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible" && active) acquire()
        }
        document.addEventListener("visibilitychange", handleVisibilityChange)
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange)
    }, [active])
}